import React from "react";
import { Table, Input, Button, Pagination, Spin ,Checkbox } from "antd";
import DateFilter from "../component/DateFilter/index";
import Export from "../component/Export";
import "./index.less";
import CommonBreadcrumb from "../../../components/CommonBreadcrumb";
import Statistics from "../component/Statistics";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
// import { createFromIconfontCN } from '@ant-design/icons';
// const IconFont = createFromIconfontCN({
//     scriptUrl: ['//at.alicdn.com/t/font_721231_vr27zuu7ef.js']
// });
import IconFont from "@components/IconFont/index";
const { Search } = Input;

class Behavior extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading: true,
            //数据源
            list: [],
            pageSize: 100,
            pageIndex: 1,
            total: 0,
            extra: {},
            isQueryApplyEssaonePlatform:false
        };
        this.params = {
            statisticsDays: 30,
        };
        this.sort = {};
    }

    /**
     *  获取表单头
     *
     */
    getColumns() {
        return [
            {
                title: __getServerLanguage('CaiGouShang'),
                width: 150,
                fixed: "left",
                key: "1",
                render: (text = {}, record, index) => (
                    <Link to={`/customer/detail?id=${text.buyerId}`}>{text.buyerCode}</Link>
                ),
            },{
                title: __getServerLanguage('GenJinRen'),//跟进人
                width: 150,
                dataIndex: "foreignUserName",
            },
            {
                title: __getServerLanguage('ZhuCeShiJian'),
                key: "2",
                render: (text = {}, record, index) => (
                    <span key={index}>
                        {text.registerTime
                            ? dayjs(text.registerTime).format("YYYY-MM-DD")
                            : "-"}
                    </span>
                ),
            },
            {
                title: __getServerLanguage('DengLuTianShu'),
                dataIndex: "loginNum",
                key: "3",
            },
            {
                title: __getServerLanguage('ZuiJinFangWenShiJian'),
                key: "lastVisitTimeOrderType",
                sorter: true,
                render: (text = {}, record, index) => (
                    <span key={index}>
                        {text.lastVisitTime
                            ? dayjs(text.lastVisitTime).format("YYYY-MM-DD")
                            : "-"}
                    </span>
                ),
            },
            {
                title: __getServerLanguage('JiaGouKuanShu'),
                key: "addCartNumOrderType",
                sorter: true,
                render: (text = {}, record, index) => (
                    <span key={index}>{text.addCartSkuNum || "-"}</span>
                ),
            },
            {
                title: __getServerLanguage('ZuiJinJiaGouShiJian'),
                key: "lastAddCartTimeOrderType",
                width: 300,
                sorter: true,
                render: (text = {}, record, index) => (
                    <span key={index}>
                        {text.lastAddCartTime
                            ? dayjs(text.lastAddCartTime).format("YYYY-MM-DD")
                            : "-"}
                    </span>
                ),
            },
            {
                title: __getServerLanguage('KaiTongESSAONE'),
                key: "isApplyEssaonePlatform",
                width: 100,
                render: (text = {}, record, index) => (
                    <span key={index} style={{color:`${text.isApplyEssaonePlatform ===0?'red':'green'}`}}>
                        {text.isApplyEssaonePlatform ===0?__getServerLanguage('WeiKaiTong'):__getServerLanguage('YiKaiTong')}
                    </span>
                ),
            },
            {
                title: __getServerLanguage('CaoZuo'),
                width: 110,
                fixed: "right",
                render: (text = {}, record, index) => (
                    <div key={index}>
                        <Link
                            className="link"
                            to={`/dataStatistics/cart?id=${text.buyerId}`}
                        >
                            <IconFont
                                type="icon-gouwuche-icon"
                                className="hover-hide"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                            <IconFont
                                type="icon-gouwuche-icon-1"
                                className="hover-show"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                        </Link>
                        <Link
                            className="link"
                            to={`/dataStatistics/po?id=${text.buyerId}`}
                        >
                            <IconFont
                                type="icon-xiangqing"
                                className="hover-hide"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                            <IconFont
                                type="icon-xiangqing-1"
                                className="hover-show"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                        </Link>
                    </div>
                ),
                key: "7",
            },
        ];
    }

    /**
     * 搜索回调
     **/
    onSearch = (value) => {
        this.params.keyword = value;
        this.getData(1);
    };

    /**
     * 切换分页
     * @param page 切换到第几页
     * @param pageSize
     **/
    onChangePage = (page, pageSize) => {
        this.getData(page, pageSize);
    };

    /**
     * 获取数据
     **/
    getData(pageIndex, pageSize) {
        this.setState(
            {
                loading: true,
            },
            () => {
                let postData = {
                    pagingQuery: {
                        pageIndex: pageIndex || this.state.pageIndex,
                        pageSize: pageSize || this.state.pageSize,
                    },
                };

                // 筛选
                if (this.params.keyword) {
                    postData.keyword = this.params.keyword;
                }


                if(this.state.isQueryApplyEssaonePlatform  ){
                    postData.isQueryApplyEssaonePlatform = 0;
                }


                if (this.sort.addCartNumOrderType) {
                    postData.addCartNumOrderType = this.sort.addCartNumOrderType;
                }
                if (this.sort.lastVisitTimeOrderType) {
                    postData.lastVisitTimeOrderType = this.sort.lastVisitTimeOrderType;
                }
                if (this.sort.lastAddCartTimeOrderType) {
                    postData.lastAddCartTimeOrderType = this.sort.lastAddCartTimeOrderType;
                }
                if (this.params.statisticsDays) {
                    postData.statisticsDays = parseInt(
                        this.params.statisticsDays
                    );
                }
                
                $.ajax({
                    url: "/service/mg/statistics/behavior/list",
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(postData),
                    success: (res) => {
                        let data = {
                            loading: false,
                        };
                        if (res.success && res.valid) {
                            res.models.map(function (item, index) {
                                item.key = index;
                            });
                            data = Object.assign(data, {
                                list: res.models || [],
                                extra: res.extra || {},
                            });
                        }
                        //分页
                        if (res.paging) {
                            data = Object.assign(data, {
                                pageIndex: res.paging.pageNum,
                                pageSize: res.paging.pageSize,
                                total: res.paging.total,
                            });
                        }
                        this.setState(data);
                    },
                    error: () => {
                        let data = {
                            loading: false,
                        };
                        this.setState(data);
                    },
                });
            }
        );
    }

    componentDidMount() {
        this.getData();
    }

    /**
     * 时间回调
     **/
    dateFilterCallBack(statisticsDays) {
        this.params.statisticsDays = statisticsDays;
        this.getData(1);
    }

    /**
     * 表格回调
     **/
    tableChange = (pagination, filters, sorter) => {
        this.sort = {};
        if (sorter && sorter.columnKey&&sorter["order"]) {
            this.sort[sorter.columnKey] =
                sorter["order"] == "ascend" ? "ASC" : "DESC";
        }
        this.getData(1);
    };

    render() {
        let state = this.state;
        let columns = this.getColumns();
        let { loading, list, extra,isQueryApplyEssaonePlatform } = state;

        return (
            <div>
                <CommonBreadcrumb
                    list={[{ name:__getServerLanguage('CaiGouShangHangWeiShuJu') }]}
                ></CommonBreadcrumb>
                <Spin spinning={loading}>
                    <div className="main-wrap behavior-wrap">
                        {/*标题*/}
                        <div>
                            <span className="title fw_700 font-18">{__getServerLanguage('CaiGouShangHangWeiShuJu')}</span>
                            <span className="date-filter">
                                <DateFilter
                                    days={this.params.statisticsDays}
                                    callBack={this.dateFilterCallBack.bind(
                                        this
                                    )}
                                ></DateFilter>
                            </span>
                        </div>

                        {/*统计*/}
                        <div>
                            <Statistics model={extra}></Statistics>
                        </div>

                        {/*操作栏*/}
                        <div className="option-wrap">
                            <div>
                            <Search
                                placeholder={__getServerLanguage('QingShuRuCaiGouShangBianMaHuoMingCheng')}
                                onSearch={this.onSearch}
                                style={{ width: 300 }}
                            />

                            <span className="lineH_32">
                                <Checkbox className="ml_8" checked={isQueryApplyEssaonePlatform}
                                    onChange={(dat)=>{
                                        const {checked}= dat.target;
                                        this.setState({
                                            isQueryApplyEssaonePlatform:checked
                                        },() => {
                                            this.onSearch()
                                        })
                                    }}>{__getServerLanguage('WeiKaiTongESSAONE')}</Checkbox>
                            </span>

                            </div>
                            <Export authName="DataStatistics-Behavior-Export-Button"></Export>
                        </div>

                        {/*表格*/}
                        <div>
                            <Table
                                sticky={true}
                                onChange={this.tableChange}
                                columns={columns}
                                pagination={false}
                                dataSource={list}
                                scroll={{ x: 1200 }}
                            />
                        </div>

                        {/*分页*/}
                        <div
                            className="pagination-wrap"
                            style={{
                                display: list.length > 0 ? "block" : "none",
                            }}
                        >
                            <Pagination
                                showQuickJumper
                                showTotal={total => (
                                    `Total ${total} items`
                                )}
                                current={state.pageIndex || 1}
                                defaultPageSize={state.pageSize || 10}
                                defaultCurrent={state.pageIndex || 1}
                                total={state.total || 0}
                                onChange={this.onChangePage.bind(this)}
                            />
                        </div>
                    </div>
                </Spin>
            </div>
        );
    }
}

Behavior.defaultProps = {};

Behavior.propTypes = {};
export default Behavior;
